import React from 'react';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import { BrowserRouter } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import { msalConfig } from './config/authConfig';
import { HITLContextProviders } from './contexts';
import { AuthGuard, SessionManager } from './components/auth';
import { MainLayout } from './components/layout/MainLayout';
import { NotificationSystem } from './components/feedback';

// Create MSAL instance — used for all environments (production + demo).
// Exported so class-based services can acquire tokens outside React context.
export const msalInstance = new PublicClientApplication(msalConfig);

const App: React.FC = () => {
  // All environments (production + demo) use Entra ID authentication
  return (
    <MsalProvider instance={msalInstance}>
      <CssBaseline />
      <HITLContextProviders>
        <AuthGuard>
          <SessionManager>
            <BrowserRouter>
              <MainLayout />
            </BrowserRouter>
            <NotificationSystem />
          </SessionManager>
        </AuthGuard>
      </HITLContextProviders>
    </MsalProvider>
  );
};

export default App;
